// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"de2e7b89","239":"a1cba998","455":"59dcd0dc"}[chunkId] + ".chunk.js";
};